import { Column, ColumnConfig } from "@ant-design/charts";
import { Chart } from "@antv/g2/lib";
import { Meta } from "@antv/g2plot";

import { ChartDataProps, DailyChartData } from "../../../model/chart";
import { dailyGarminStepTheme } from "../theme/daily_garmin_step_theme";
import { ChartCard } from "../template/chart_card";
import { defaultDailyChartXAxisConfig } from "../../../lib/chart_data/util/formatter";
import { useEffect, useMemo, useState } from "react";
// import {ChartAnnotation} from '../template/time_series_data_chart'

export const GarminDailySummaryStepChart = (props: ChartDataProps<DailyChartData>) => {
  const { height, width, title, data } = props;
  const [chartInstance, setChartInstance] = useState<Chart | undefined>();
  const xField: keyof DailyChartData = "yymmdd";
  const yField: keyof DailyChartData = "value";
  const meta: { [key in keyof DailyChartData]: Meta } = {
    yymmdd: {
      alias: "Date",
    },
    value: {
      alias: "Total steps",
    },
  };
  const yAxisConfig = {
    title: { text: "Total steps" },
  };

  // const generateStepGoalMaker = (goal: number): ChartAnnotation[] => {
  //   const generateHorizontalLineAnnoation = (value: number, color: string): ChartAnnotation => {
  //     return {
  //       type: 'line',
  //       content: {
  //         start: ['start', value],
  //         end: ['end', value],
  //         top: true,
  //         style: {
  //           stroke: color,
  //           lineWidth: 2,
  //         },
  //         text: {
  //           content: `goal:${value}`,
  //           position: 'start',
  //           autoRotate: false,
  //           offsetY: 15,
  //           style: {
  //             fill: color,
  //           },
  //         },
  //       },
  //     }
  //   }
  //   return [generateHorizontalLineAnnoation(goal, '#ff8000')]
  // }

  // const chartAnnotations = generateStepGoalMaker(10000)

  // const drawAnnotations = () => {
  //   if (chartInstance && chartAnnotations) {
  //     chartAnnotations.forEach((annotation) => {
  //       if (annotation.type === 'line') {
  //         chartInstance.annotation().line(annotation.content)
  //       } else if (annotation.type === 'region') {
  //         chartInstance.annotation().region(annotation.content)
  //       }
  //     })
  //     chartInstance.render()
  //   }
  // }

  useEffect(() => {
    if (chartInstance) {
      chartInstance.changeData(data);
      // drawAnnotations()
    }
  }, [chartInstance, data]);

  const columnConfig: ColumnConfig = {
    data: [],
    autoFit: true,
    xField,
    yField,
    xAxis: defaultDailyChartXAxisConfig,
    yAxis: yAxisConfig,
    meta,
    theme: dailyGarminStepTheme,
    onReady: (chart) => {
      setChartInstance(chart.chart);
    },
  };

  const config = useMemo<ColumnConfig>(() => {
    return columnConfig;
  }, []);

  const chartCardProps = {
    height: height,
    width: width,
    chartTitle: title ?? "Garmin Connect Steps",
    hintDescription: "",
    chart: <Column {...config} />,
  };
  return <ChartCard {...chartCardProps} />;
};
